<template>
  <div id="game-zone" class="margin-10">
    <div class="padding-5"></div>
    <div v-if="allTournaments.length">
      <div class="bg-light align-ver radius-3 padding-10 box-shadow margin-bottom-10" v-for="tour in allTournaments" @click="redirectTo('tournament', tour.params)">
        <div class="pos-rel margin-bottom-10">
          <img class="full-width game-banner" :src="tour.game_banner">
          <div class="live-timer bg-red pos-abs text-light font-bold padding-10">
            <span>{{tour.is_live ? getTranslatedText("LIVE") : getTranslatedText("Starts")}}</span><br><span class="text-small">{{tour.is_live ? getTranslatedText('Ends') : getTranslatedText('In')}}: <span :id="'tr_timer_' + tour.id"></span></span>
          </div>
        </div>
        <div class="align-hor center-ver space-between">
          <div class="text-left">
            <div class="font-bold margin-bottom-5">{{tour.title}}</div>
            <div class="align-hor center-ver">Total Prize: <img class="small-icon padding-vertical-5" :src="tour.prize_icon_url"> {{formatReward(tour.prize_type, tour.total_prize, true)}}</div>
          </div>
          <div>
            <!-- <button class="custom-button small text-light padding-0520 radius-30" :style="{background: bgTheme}" @click="redirectTo('tournament', tour.params)">Play</button> -->
            <button class="custom-button small text-light padding-0520 radius-3" :style="{background: bgTheme}">Play</button>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 85vh;" v-if="allTournaments.length===0" class="align-ver center-hor bg-light">
      <div style="display: flex; justify-content: center; align-items: center; width: 100%">
        <img src="@/assets/no-data.svg" class="w20">
      </div>

      <div>
        No Tournament Live!
      </div>
      </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  export default {
    mixins: [globals],
    data() {
      return {
        page: 1,
        all_tournaments: [],
        has_no_tournaments: false
      }
    },
    computed: {
      allTournaments() {
        return this.all_tournaments;
      },
      hasNoTournaments() {
        return this.has_no_tournaments;
      }
    },
    methods: {
      getGamesData() {
        var self = this;
        var url = this.$store.getters.flyyDomain + '/v2/fetch_tournaments';
        var headers = this.$store.getters.headers;
        axios.get(url, {
          mode: 'no-cors',
          headers: headers,
          params: {
            page: this.page,
          }
        }).then((resp) => {
          var data = resp.data;
          if(data.success) {
            var tempArr = [];
            if(data.tournaments.length > 0) {
              data.tournaments.forEach(function(v) {
                if(v.is_live) {
                  tempArr.push({
                    id: v.id,
                    title: v.title,
                    total_prize: v.total_prize,
                    prize_type: v.prize_type,
                    prize_icon_url: v.prize_icon_url,
                    game_banner: v.game_banner,
                    is_live: v.is_live,
                    ends_at: v.ends_at,
                    starts_at: v.starts_at,
                    params: {
                      partner: self.$store.getters.headers['X-Key'],
                      contact_number: self.extUid,
                      game_id: v.game_id
                    }
                  })
                }
              });
              this.all_tournaments = tempArr;
              this.$store.state.allTournamentsList = tempArr;
              this.has_no_tournaments = false;
            } else {
              this.has_no_tournaments = true;
            }
          }
        });
      }
    },
    created() {
      this.$store.state.tournamentStatus = []
      this.$store.state.showHeader = true;
      this.$store.state.showWallet = false;
      this.$store.state.showHeaderBalance = false;
      this.$store.state.user.headerBalance.show = false;
      this.$store.state.showHistory = true;
      this.$store.state.headTitle = "Play & Earn";
      // this.getGamesData();
    },
    mounted() {
      clearInterval(this.$store.state.refreshTournamentTimer);
      clearInterval(this.$store.state.timer);
      this.getGamesData();
      this.getTimerForTimerArray();
    }
  }
</script>
<style>
  .live-timer {
    top: 5px;
    right: -5px;
    background: #d02828;
  }
  .game-banner {
    min-height: 165px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/game-zone.vue